import { SelectedTestSuite } from '@/app/features/reports/types/selected-test-suite';
import { TestStatus } from '@app.raytd.com/common/types/test-form';
import { RefObject, createContext, useContext } from 'react';

// Define a type for the field definition based on your TestSuite structure
// Assuming it might have at least these properties. Adjust as needed.
interface FieldDefinition {
    field_name: string;
    type: string; // e.g., 'text', 'number', 'select', etc.
    label?: string;
    required?: boolean;
    active?: boolean;
    // Add any other relevant properties from your custom_fields or settings structure
}

interface TestFormContextType {
    formId: string;
    isExistingTest: boolean;
    isFormDirty: boolean;
    isFormValid: boolean;
    isFormReady: boolean;
    isRequiredFieldsFilled: boolean;
    isReadyForNonDraftStatus: boolean;
    selectedTestSuite: SelectedTestSuite | undefined;
    viewportRef: RefObject<HTMLDivElement>;
    getFieldVisibility: (fieldName: string) => boolean;
    getFieldRequirement: (fieldName: string) => boolean;
    getFieldDefinition: (fieldName: string) => FieldDefinition | undefined;
    onStatusChange: (status: TestStatus) => Promise<void>;
    onFastFillChanged: (field_id: string) => void;
    fastFillErrorFields: Set<string>;
    registerFastFillError: (fieldId: string) => void;
    unregisterFastFillError: (fieldId: string) => void;
    localFastFillAccepted: boolean;
    setLocalFastFillAccepted: (value: boolean) => void;
    initialErrorState: any;
    isSaving: boolean;
    formRef: HTMLFormElement | null;
    saveForm: () => Promise<boolean>;
}

const TestFormContext = createContext<TestFormContextType | null>(null);

export const useTestFormContext = () => {
    const context = useContext(TestFormContext);
    if (!context) {
        throw new Error('useTestFormContext must be used within a TestFormProvider');
    }
    return context;
}

export default TestFormContext;

// Export the FieldDefinition type if needed elsewhere
export type { FieldDefinition };
